<style lang="scss" scoped>
.wrap {
  padding: 30px;
  background: #fff;
  margin-bottom: 30px;
}
.list {
  width: 100%;
  margin-bottom: 30px;
  .iconyuyin {
    font-size: 30px;
    color: #173bcf;
    font-size: 32px;
    line-height: 36px;
    cursor: pointer;
    vertical-align: middle;
    margin-right: 20px;
  }
}
.search {
  width: 200px;
  margin-right: 20px;
}
</style>

<template>
  <div>
    <div class="clearfix mb20">
      <soundAdd class="fr" :id="id" @confirm="confirmVoice">
        <el-button type="primary">新建语音</el-button>
      </soundAdd>
      <el-input class="search fr" placeholder="搜索语音" v-model="key">
        <i slot="suffix" class="el-input__icon el-icon-search pointer" @click="search"></i>
      </el-input>
    </div>
    <div class="wrap">
      <el-table :data="data" class="list">
        <el-table-column label="名称">
          <template slot-scope="scope">
            <i class="iconfont iconyuyin" @click="play(scope.row.content)"></i>
            {{scope.row.content.title}}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="200">
          <template slot-scope="scope">
            <div>{{momentutc(scope.row.createdDate)}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="del(scope.row.materialId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="alignc">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="changePage"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import soundAdd from '@/components/lib/soundAdd';
export default {
  components: {
    soundAdd,
  },
  computed: {},
  props: ['id'],
  data() {
    return {
      key: '',
      radio: '',
      data: [],
      dialog: false,
      page: 1,
      pageSize: 8,
      total: 0,
      voice: '',
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.voice) {
      this.voice.stop();
      this.voice.destruct();
    }
    next();
  },
  methods: {
    async changePage(val) {
      this.page = val;
      await this.getData();
    },
    async getData(search) {
      let res = search
        ? await this.$http.get(
            `/api/${this.id}/materials?key=${this.key}&page=${this.page}&size=${
              this.pageSize
            }&type=4`,
          )
        : await this.$http.get(
            `/api/${this.id}/materials?page=${this.page}&size=${
              this.pageSize
            }&type=4`,
          );
      this.data = res.list;
      this.total = res.totalSize;
    },
    async confirmVoice() {
      await this.getData();
    },
    show() {
      this.dialog = true;
    },
    play(content) {
      if (!content.voiceUrl) {
        this.message.warning('该音频暂未通过审核');
        return;
      }
      if (this.voice) {
        this.voice.stop();
        this.voice.destruct();
      }
      this.voice = this.$soundManager.createSound({
        url: content.voiceUrl,
      });
      this.voice.play();
    },
    async del(id) {
      let res = await this.$confirm(
        '此操作将永久删除该文件, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      );
      if (res) {
        this.$http.delete(`/api/${this.id}/materials`, {
          data: { materialsId: [id] },
        });
        await this.getData();
      }
    },
    async search() {
      await this.getData(1);
    },
  },
  async mounted() {
    let res = await this.$http.get(
      `/api/${this.id}/materials?page=${this.page}&size=${
        this.pageSize
      }&type=4`,
    );
    this.data = res.list;
    this.total = res.totalSize;
    console.log(res);
  },
};
</script>
